import { Caption, H4, Image } from '@collab/atoms';
import { Tab, TabContainer } from '@collab/molecules';

const ColorContrast: React.FC = () => (
  <TabContainer headerBg="primary">
    <Tab title="Light UI" paddedContent>
      <H4> Foreground colours on primary background colour </H4>

      <Image
        alt="Visual shows light UI foreground colours on primary light UI background colour. This visual also displays the resulting colour contrast ratios."
        src="/images/components/colour/fg_on_pri_bg-light.svg"
        aspectRatio={[4, 3]}
      />
      <Caption>
        * Contrast ratios below 4.5:1 must only occur with non-critical UI and
        never content.
      </Caption>

      <H4> Foreground colours on secondary background colour </H4>

      <Image
        alt="Visual shows light UI foreground colours on secondary light UI background colour. This visual also displays the resulting colour contrast ratios."
        src="/images/components/colour/fg_on_sec_bg-light.svg"
        aspectRatio={[4, 3]}
      />
      <Caption>
        * Contrast ratios below 4.5:1 must only occur with non-critical UI and
        never content.
      </Caption>

      <H4> Button label contrasts </H4>

      <Image
        alt="Visual shows white text label contrasts on both primary blue and accent blue colours for light UI buttons."
        src="/images/components/colour/button-label-contrasts-light.svg"
      />
    </Tab>

    <Tab title="Dark UI" paddedContent>
      <H4> Foreground colours on primary background colour </H4>

      <Image
        alt="Visual shows dark UI foreground colours on primary dark UI background colour. This visual also displays the resulting colour contrast ratios."
        src="/images/components/colour/fg_on_pri_bg-dark.svg"
        aspectRatio={[4, 3]}
      />
      <Caption>
        * Contrast ratios below 4.5:1 must only occur with non-critical UI and
        never content.
      </Caption>

      <H4> Foreground colours on secondary background colour </H4>

      <Image
        alt="Visual shows dark UI foreground colours on secondary dark UI background colour. This visual also displays the resulting colour contrast ratios."
        src="/images/components/colour/fg_on_sec_bg-dark.svg"
        aspectRatio={[4, 3]}
      />
      <Caption>
        * Contrast ratios below 4.5:1 must only occur with non-critical UI and
        never content.
      </Caption>

      <H4> Button label contrasts </H4>

      <Image
        alt="Visual shows white text label contrasts on both primary blue and accent blue colours for dark UI buttons."
        src="/images/components/colour/button-label-contrasts-dark.svg"
      />
    </Tab>
  </TabContainer>
);

export default ColorContrast;
